export default __webpack_public_path__ + "static/media/receive.ffcec2f5.gif";